/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isBrowser, isMobile } from 'react-device-detect';
import { useHistory, useLocation } from 'react-router-dom';
import { useSetting } from '../../../utilities/sharedHooks/settings';

const LoadCardError = () => {
  const { t: translate } = useTranslation();

  const { state } = useLocation();
  const history = useHistory();

  const [ledgerSupportEmailAddress] = useSetting('server_configurations', 'support_email_address');

  useEffect(() => {
    if (!state?.cardHasIssue) {
      history.push('/');
    }
  }, []);

  return (
    <>
      {isMobile && (
        <div className="d-flex flex-row mt-4 ms-3">
          <p className="text-f3 text-bold">{translate('card_tab_label')}</p>{' '}
        </div>
      )}
      <div
        className={`d-flex flex-column w-100 ${
          isBrowser ? 'h-85vh' : 'h-65vh'
        } justify-content-center align-items-center`}>
        <div>
          <img className="w-100" src="./assets/images/warning.png" alt="Success" />
        </div>
        <div className={`text-center mt-4 pt-2 ${isBrowser ? 'w-50' : 'px-3'}`}>
          <p className="text-f5 text-bold letter-spacing-2" style={{ lineHeight: '24px' }}>
            {translate('failed_loading_card_title')}
          </p>
          <p className="text-f6 letter-spacing-3 mt-3" style={{ lineHeight: '16px' }}>
            {translate('failed_loading_card_note_1')}
          </p>
          <p className="text-f6 letter-spacing-3" style={{ lineHeight: '16px' }}>
            <Trans
              i18nKey="failed_loading_card_note_2"
              values={{
                support_email: ledgerSupportEmailAddress,
              }}
              components={[
                // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
                <a
                  key="contact-link-2"
                  className="text-decoration-none text-primary"
                  href={`mailto:${ledgerSupportEmailAddress}`}
                  rel="noreferrer"
                />,
              ]}
            />
          </p>
          <p className="text-f6 letter-spacing-3 mt-4" style={{ lineHeight: '16px' }}>
            {translate('failed_loading_card_note_3')}
          </p>
        </div>
      </div>
    </>
  );
};

export default LoadCardError;
